import React, { useEffect, useState } from "react"
import {
	Button,
	Divider,
	FormControl,
	FormControlLabel,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	TextField,
	Tooltip,
	Typography,
	makeStyles,
} from "@material-ui/core"
import { Close as CloseIcon, KeyboardArrowDown, InfoOutlined as InfoIcon } from "@material-ui/icons"
import { SwitchControl } from "../../common/Switch"
import { DatePicker } from "../../common/DatePicker"
import { useFormik } from "formik"
import * as yup from "yup"
import moment from "moment"
import {
	DATE_PICKER_FORMAT,
	convertFilterToString,
	getConceptsById,
	getQueryParams,
	getSearchNameById,
	payloadParsing,
	searchTermDeparse,
	searchTermParse,
} from "../../../utils"
import { useDispatch, useSelector } from "react-redux"
import { getUsers } from "../../../actions/infoActions"
import { Skeleton } from "@material-ui/lab"
import {
	createReviewRequest,
	createReviewRequestReset,
	getReviewListRequest,
	isReviewUpdateTrigger,
	resetReviewForm,
	setReviewAsignee,
	setReviewCurrentAsignee,
	setReviewFormOpen,
	updateReviewMetada,
} from "../../../actions/reviewActions"
import _ from "lodash"
import { setNotification } from "../../../actions/notificationActions"
import { useTranslation } from "react-i18next"
import useStyles from "./styles"
import { useParams } from "react-router-dom"
import AutoAssignmentView from "./AutoAssignmentView"
import PercentagePie from "./PercentagePie"

const MenuProps = {
	PaperProps: {
		style: {
			maxWidth: 216,
			maxHeight: 150,
			textTransform: "capitalize",
		},
	},
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	variant: "menu",
	getContentAnchorEl: null,
}

const ReviewForm = ({ onClose, selectedSearch, filesCount, loadSavedSearch, mapDataToState = () => {} }) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [t] = useTranslation("global")

	//redux states
	const usersList = useSelector((state) => state.info?.usersList || [])
	const isUsersListLoading = useSelector((state) => state.info?.isLoading || false)
	const reviewAssignee = useSelector((state) => state.review?.reviewAssignee)
	const isSaving = useSelector((state) => state.review?.isSaving)
	const currentSearch = useSelector((state) => state.currentSearchs?.search)
	const savedConcepts = useSelector((state) => state?.buildconcept?.user_saved_build_concepts_unshared) || []
	const sharedConcepts = useSelector((state) => state?.buildconcept?.user_saved_build_concepts_shared) || []
	const searchList = useSelector((state) => state?.savedSearch?.savedSearchs) || []
	const selectedReview = useSelector((state) => state.review?.review)
	const isUpdateTrigger = useSelector((state) => state.review?.isUpdateTrigger)
	const is_case_admin = useSelector((state) => state.review?.is_case_admin)
	const assigneeMap = useSelector((state) => state.review?.assigneeMap)
	//local states
	const [users, setUsers] = useState("")
	//Automatic assignments local states
	const [autoAssignment, setAutoAssignment] = useState(false)
	const [assignmentDetails, setAssignmentDetails] = useState({
		userRow: [
			{
				index: Math.random(),
				assignTo: "",
				percentage: "",
				assignToErr: false,
				percentageErr: false,
				assignToErrMsg: "",
				percentageErrMsg: "",
			},
		],
	})
	const [isAssigmentDone, setIsAssignmentDone] = useState(false)
	const [isAutoAssignmentFormInValid, setIsAutoAssignmentFormInValid] = useState(false)

	//form validation
	const validationSchema = yup.object({
		name: yup.string().required(t("review.reviewForm.nameRequired")),
		objective: yup.string().required(t("review.reviewForm.goalRequired")),
		due_date: yup.date(),
		exclusive: yup.boolean(),
		tags_copied: yup.boolean(),
		file_equal_assignment: yup.boolean(),
		user_assigned_method: yup.boolean(),
		assigned: yup.object({}),
		search_criteria: yup.object({}),
		users: yup.array().of(yup.string().required(t("user.formErrors.required"))),
	})

	const formik = useFormik({
		initialValues: {
			name: selectedReview?.name ? selectedReview?.name : "",
			objective: selectedReview?.objective ? selectedReview?.objective : "",
			due_date: selectedReview?.due_date ? new Date(selectedReview?.due_date).toISOString() : new Date().toISOString(),
			exclusive: selectedReview?.exclusive ? selectedReview?.exclusive : true,
			tags_copied: selectedReview?.tags_copied ? selectedReview?.tags_copied : false,
			file_equal_assignment: selectedReview?.file_equal_assignment ? selectedReview?.file_equal_assignment : false,
			user_assigned_method: String(selectedReview?.user_assigned_method ? selectedReview?.user_assigned_method : false),
			assigned: {},
			search_criteria: selectedReview?.search_criteria ? selectedReview?.search_criteria : {},
			users: [],
		},
		validationSchema: validationSchema,
		onSubmit: (values) => {
			//TOD0 -  Need to prepare and send assign to and percentage data to the API once ready
			const sanitizedAssigneeData = sanitizedAssignee(reviewAssignee)
			const userAssignmentData = prePaireAssignmentData(values?.file_equal_assignment, assignmentDetails)

			// //If review is selected then Update the review else Creare review
			// const payload = selectedReview?.id
			// 	? {
			// 			objective: values.objective,
			// 			due_date: values.due_date,
			// 			assigned: sanitizedAssigneeData,
			// 			id: selectedReview?.id,
			// 	  }
			// 	: {
			// 			...values,
			// 			user_assigned_method: JSON.parse(values.user_assigned_method),
			// 			job_id: jobId,
			// 			assigned: sanitizedAssigneeData,
			// 	  }

			//If review is selected then Update the review else Creare review
			const queryString = getQueryParams()
			const reviewSearchCriteria = !_.isEmpty(queryString) ? payloadParsing(queryString) : {}

			if (selectedReview?.id) {
				//update review
				const payload = {
					objective: values.objective,
					due_date: values.due_date,
					assigned: sanitizedAssigneeData,
					id: selectedReview?.id,
					search_criteria: isUpdateTrigger ? reviewSearchCriteria : values.search_criteria,
					//user_assigned_method: JSON.parse(values.user_assigned_method),//on update in not required, plus currently we not support to change user_assigned_method on update flow
				}

				const unassigned = getUnassignedFileIds(assigneeMap)
				if (unassigned?.length) {
					payload["assigned"] = { ...payload.assigned, unassigned }
				}

				dispatch(createReviewRequest(payload))
			} else {
				//create review
				const payload = {
					...values,

					user_assigned_method: JSON.parse(values.user_assigned_method),
					assigned: sanitizedAssigneeData,
					search_criteria: reviewSearchCriteria,
				}
				// in case of automatic review
				if (values?.user_assigned_method) {
					if (userAssignmentData) {
						payload["users"] = userAssignmentData
						payload["assigned"] = {}
						delete payload.assigned //if automatic then dont need to send the assigned as payload
					} else {
						console.log("Invalid Form Data")
						//return false
					}
				} else {
					payload["users"] = {}
				}

				dispatch(createReviewRequest(payload))
			}

			dispatch(isReviewUpdateTrigger(false))
		},
	})

	const sanitizedAssignee = (reviewAssigneeObj) => {
		const reviewAssignees = _.cloneDeep(reviewAssigneeObj)
		for (var userId in reviewAssignees) {
			if (reviewAssignees.hasOwnProperty(userId)) {
				if (reviewAssignees[userId].length === 0) {
					delete reviewAssignees[userId]
				}
			}
		}
		return reviewAssignees
	}

	const getUnassignedFileIds = (inputMap) => {
		const nullValues = []

		for (const [key, value] of inputMap.entries()) {
			if (value === null) {
				nullValues.push(key)
			}
		}

		return nullValues
	}

	const prePaireAssignmentData = (isEqualAssignment) => {
		if (isEqualAssignment) {
			if (formik?.values?.users?.length > 0) {
				setIsAutoAssignmentFormInValid(false)
				return formik?.values?.users
			} else {
				setIsAutoAssignmentFormInValid(true)
				return false
			}
		} else {
			if (!autoAssignmentInvalid()) {
				let finalAssignmentData = []
				setIsAutoAssignmentFormInValid(false)
				assignmentDetails?.userRow?.map((item) => {
					const { assignTo, percentage } = item

					finalAssignmentData?.push({ [assignTo]: parseInt(percentage) })
				})
				return Object.assign({}, ...finalAssignmentData)
			} else {
				setIsAutoAssignmentFormInValid(true)
				return false
			}
		}
	}

	const autoAssignmentInvalid = () => {
		const invalidFields = []
		assignmentDetails?.userRow?.map((item) => {
			if (item?.assignTo === "" || item?.percentage === "") {
				invalidFields?.push(item?.index)
			}
		})

		return invalidFields?.length > 0 ? true : false
	}

	const validatePercentage = (percentage) => {
		const NUM_REGX = /^[1-9][0-9]?$|^100$/
		return NUM_REGX?.test(percentage) ? true : false
	}

	const disabledDelegate =
		autoAssignment || formik.values.file_equal_assignment
			? !isAssigmentDone && !formik.values.users.length
			: Object.values(reviewAssignee).flat().length
			? false
			: true

	useEffect(() => {
		if (autoAssignment === true) {
			// Clear out the manual selection
			dispatch(resetReviewForm({ is_case_admin }))
			dispatch(isReviewUpdateTrigger(false))
			dispatch(setReviewFormOpen(true))
		} else {
			setAssignmentDetails({
				userRow: [
					{
						index: Math.random(),
						assignTo: "",
						percentage: "",
						assignToErr: false,
						percentageErr: false,
						assignToErrMsg: "",
						percentageErrMsg: "",
					},
				],
			})
		}
	}, [autoAssignment])

	useEffect(() => {
		if (formik?.values?.file_equal_assignment) {
			setAssignmentDetails({
				userRow: [
					{
						index: Math.random(),
						assignTo: "",
						percentage: "",
						assignToErr: false,
						percentageErr: false,
						assignToErrMsg: "",
						percentageErrMsg: "",
					},
				],
			})
		} else {
			formik?.setFieldValue("users", [])
		}
	}, [formik?.values?.file_equal_assignment])

	//on load
	useEffect(() => {
		dispatch(getUsers())
	}, [])

	const SkeletonList = () => {
		return Array(4)
			.fill()
			.map((data, i) => (
				<div key={i} style={{ padding: "0px 15px" }}>
					<Skeleton key={i} width={"100%"} height={50} />
				</div>
			))
	}

	const userListItems = usersList.reduce(
		(result, user) => {
			result.push(
				<MenuItem key={user?.user_id} value={user?.user_id}>
					{user?.username}
				</MenuItem>
			)

			return result
		},
		[
			// <MenuItem value="">
			// 	<em>None</em>
			// </MenuItem>,
		]
	)

	const handleUserChange = (e) => {
		const userId = e.target.value
		setUsers(userId) //update local state
		if (!userId) return

		dispatch(setReviewCurrentAsignee(userId))
		if (!Object.hasOwn(reviewAssignee, userId)) {
			const reviewAssigneeOnj = { ...reviewAssignee }
			reviewAssigneeOnj[userId] = []
			dispatch(setReviewAsignee(reviewAssigneeOnj))
		}
	}

	const updateSearchResult = (search_id, isShared) => {
		let reviewClone = _.cloneDeep(selectedReview)
		if (search_id) {
			//saved search update
			const search = getSearchById(search_id)
			if (!_.isEmpty(search)) {
				//clone the object
				//let reviewClone = _.cloneDeep(selectedReview)
				reviewClone = {
					...reviewClone,
					search_params: {
						...reviewClone?.search_params,
						...search?.params,
						...search?.params?.filters,
						categories: search?.params?.categories?.map((concept) => concept?.id) || [],
						additional_params: { ...reviewClone?.search_params?.additional_params, searchName: search?.name },
						text: searchTermParse(search?.params?.text),
					},
				}

				dispatch(updateReviewMetada({ review: reviewClone, isUpdateTrigger: true }))
				loadSavedSearch(isShared ? "shared_search" : "saved_search", search)
			}
		} else {
			//all document concepts update
			if (!_.isEmpty(reviewClone?.search_params) && reviewClone?.search_params?.categories?.length > 0) {
				mapDataToState(reviewClone?.search_params) //this wil update the states (not trigger the search)
				dispatch(updateReviewMetada({ review: reviewClone, isUpdateTrigger: true })) //this will trigger the search
			}
		}
	}

	const getSearchById = (id) => {
		return searchList?.find((search) => search?.id === id)
	}

	const minDate = selectedReview?.id ? selectedReview?.due_date : new Date()
	const searchId = selectedReview?.search_params?.additional_params?.searchId
	const isSharedSearch = !!selectedReview?.search_params?.shared_search_id

	return (
		<div className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<form className={classes.form} noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
						<div className={classes.header}>
							<Typography variant="body2" className={classes.title}>
								{selectedReview?.id ? t("review.reviewForm.editReview") : t("review.reviewForm.createReview")}
							</Typography>
							<IconButton className={classes.close} onClick={onClose}>
								<CloseIcon color="primary" />
							</IconButton>
						</div>
						<Divider variant="fullWidth" className={classes.divider} />
						<div className={classes.scroll}>
							<div className={classes.formWrapper}>
								{/*This review created from search or using the concept*/}
								{selectedReview?.id &&
									(selectedReview?.search_params?.additional_params?.searchId ||
										selectedReview?.search_params?.categories?.length > 0) && (
										<Grid container spacing={1} className={classes.metadata}>
											<Grid item xs={9}>
												<Typography variant="subtitle1" className={`${classes.subtitle} ${classes.updateMsg}`}>
													{t("review.reviewForm.updateMsg")}
													<Tooltip title={t("review.reviewForm.updateTooltip")} placement="top" arrow>
														<InfoIcon className={classes.infoIcons} color="warning" />
													</Tooltip>
												</Typography>
											</Grid>
											<Grid item xs={3}>
												<Button
													variant="contained"
													color="secondary"
													className={classes.button}
													fullWidth
													onClick={() => updateSearchResult(searchId, isSharedSearch)}
													//disabled={isSaving}
												>
													{t("review.reviewForm.update")}
												</Button>
											</Grid>
										</Grid>
									)}

								<Divider variant="fullWidth" className={classes.divider} />

								<Grid container spacing={1} className={classes.metadata}>
									<Grid item xs={12}>
										<Typography variant="subtitle1" className={classes.subtitle}>
											{t("review.reviewForm.details")}
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<FormControl fullWidth className={classes.marginTopBottom}>
											<TextField
												id="name"
												label={t("review.reviewForm.reviewname")}
												variant="outlined"
												className={`${classes.textField} ${classes.formField}`}
												value={formik.values.name}
												onChange={formik.handleChange}
												error={formik.touched.name && Boolean(formik.errors.name)}
												helperText={formik.touched.name && formik.errors.name}
												disabled={selectedReview?.id}
											/>
										</FormControl>
									</Grid>

									<Grid item xs={12}>
										<FormControl fullWidth className={classes.marginTopBottom}>
											<TextField
												id="objective"
												label={t("review.reviewForm.goal")}
												multiline
												rows={4}
												variant="outlined"
												value={formik.values.objective}
												onChange={formik.handleChange}
												error={formik.touched.objective && Boolean(formik.errors.objective)}
												helperText={formik.touched.objective && formik.errors.objective}
												className={`${classes.goal} ${classes.formField}`}
											/>
										</FormControl>
									</Grid>

									<Grid item xs={12}>
										<FormControl fullWidth className={classes.marginTopBottom}>
											<DatePicker
												label={t("review.reviewForm.dueDate")}
												date={formik.values.due_date}
												setDate={(e) => {
													const date = e?._d
													if (!date) return
													formik.setFieldValue("due_date", date)
												}}
												className={`${classes.formField}`}
												minDate={minDate}
											/>
										</FormControl>
									</Grid>

									<Grid container alignItems="center" className={classes.marginBottom}>
										<Grid item xs={8}>
											<FormControl fullWidth>
												<Typography variant="subtitle1">{t("review.reviewForm.exclusive")}</Typography>
											</FormControl>
										</Grid>
										<Grid item xs={4} justifyContent="flex-end" alignItems="center" className={classes.switchwrapper}>
											<SwitchControl
												name="exclusiveReview"
												state={formik.values.exclusive}
												setState={() => {
													formik.setFieldValue("exclusive", !formik.values.exclusive)
												}}
												disabled={selectedReview?.id}
											/>
										</Grid>
									</Grid>

									<Grid container alignItems="center" className={classes.marginBottom}>
										<Grid item xs={8}>
											<FormControl fullWidth>
												<Typography variant="subtitle1">{t("review.reviewForm.copyTags")}</Typography>
											</FormControl>
										</Grid>
										<Grid item xs={4} justifyContent="flex-end" alignItems="center" className={classes.switchwrapper}>
											<SwitchControl
												name="copyTags"
												state={formik.values.tags_copied}
												setState={() => {
													formik.setFieldValue("tags_copied", !formik.values.tags_copied)
												}}
												//disabled={selectedReview?.id} // keeping this for future reference
												disabled={true}
											/>
										</Grid>
									</Grid>

									<Grid item xs={12}>
										<FormControl
											fullWidth
											className={autoAssignment ? classes.autoAssignmentMargin : classes.marginTopBottom}
										>
											<RadioGroup
												aria-label="user_assigned_method"
												name="user_assigned_method"
												value={formik.values.user_assigned_method}
												onChange={(e) => {
													formik.setFieldValue("user_assigned_method", e.currentTarget.value)
													if (e.currentTarget.value === "true") {
														setAutoAssignment(true)
														dispatch(setReviewAsignee({}))
														dispatch(setReviewCurrentAsignee(""))
														setUsers("")
													} else {
														setAutoAssignment(false)
														formik.setFieldValue("users", [])
														formik.setFieldValue("file_equal_assignment", false)
													}
												}}
											>
												<FormControlLabel
													value="false"
													control={<Radio />}
													label={t("review.reviewForm.manual")}
													id="manual"
													disabled={selectedReview?.id}
												/>

												<Grid container alignItems="center" style={{ marginBottom: 8 }}>
													<Grid item xs={8}>
														<FormControlLabel
															value="true"
															control={<Radio />}
															label={t("review.reviewForm.automatic")}
															id="automatic"
															disabled={selectedReview?.id}
														/>
													</Grid>
													<Grid
														item
														xs={4}
														justifyContent="flex-end"
														alignItems="center"
														className={classes.switchwrapper}
													>
														{autoAssignment && (
															<PercentagePie
																assignmentDeatils={assignmentDetails}
																isAssigmentDone={isAssigmentDone}
																setIsAssignmentDone={setIsAssignmentDone}
																isEqualAssignment={formik?.values?.file_equal_assignment}
																autoAssignment={autoAssignment}
															/>
														)}
													</Grid>
												</Grid>
											</RadioGroup>
										</FormControl>
									</Grid>
									{/*Auto file assignment UI  */}
									{autoAssignment ? (
										<AutoAssignmentView
											data={{
												isUsersListLoading,
												usersList,
												userListItems,
												formik,
												SkeletonList,
												MenuProps,
												assignmentDetails,
												setAssignmentDetails,
												isAssigmentDone,
												setIsAssignmentDone,
												validatePercentage,
												isAutoAssignmentFormInValid,
											}}
										/>
									) : (
										<Grid item xs={12}>
											<FormControl variant="filled" className={classes.marginTopBottom} fullWidth>
												<InputLabel id="demo-simple-select-filled-label">
													{t("review.reviewForm.assignTo")}
												</InputLabel>
												<Select
													labelId="demo-simple-select-filled-label"
													id="demo-simple-select-filled"
													fullWidth
													className={`${classes.select} ${classes.formField}`}
													MenuProps={MenuProps}
													IconComponent={KeyboardArrowDown}
													variant="outlined"
													value={users}
													onChange={handleUserChange}
													//error={sanitizedAssignee(reviewAssignee).filesCount !== filesCount}
												>
													{isUsersListLoading ? (
														<SkeletonList />
													) : usersList.length ? (
														userListItems
													) : (
														<MenuItem value="">
															<em>{t("review.noDataFound")}</em>
														</MenuItem>
													)}
												</Select>
												<Typography className={classes.assigneeInfo}>
													{t("review.reviewForm.selectFiles")}
												</Typography>
											</FormControl>
										</Grid>
									)}
								</Grid>
							</div>
						</div>
						<Divider variant="fullWidth" className={classes.divider} />
						<div className={classes.footer}>
							<Button onClick={onClose} color="primary" className={classes.button}>
								{t("review.reviewForm.cancel")}
							</Button>
							{/* <Button variant="outlined" color="primary" className={classes.button}>
								{t("review.reviewForm.assign")}
							</Button> */}
							<Button
								variant="contained"
								color="secondary"
								className={classes.button}
								onClick={formik.handleSubmit}
								disabled={isSaving || disabledDelegate}
							>
								{t("review.reviewForm.Delegate")}
							</Button>
						</div>
					</form>
				</Grid>
			</Grid>
		</div>
	)
}

export default ReviewForm
